import React from "react";
import ImageTile from "./ImageTile";

export default function PageHeader({ eyebrow, title, titleAccent, subtitle, image, emoji = "🌿", height = "min-h-[56vh] md:min-h-[64vh]", children, rightContent }) {
  return (
    <section className={`relative w-full mt-16 md:mt-16 overflow-hidden ${height}`} style={{ minHeight: "500px" }}>
      <ImageTile src={image} alt={title} emoji={emoji} className="absolute inset-0"
        imgClassName="scale-105"
        overlayClassName="bg-gradient-to-b from-[#0d1f2d]/40 via-[#0d1f2d]/45 to-[#0d1f2d]" />

      <div className="relative w-full px-4 sm:px-6 lg:px-10 max-w-[1600px] mx-auto flex items-end pt-16 md:pt-20 pb-14 md:pb-20" style={{ minHeight: "inherit" }}>
        {rightContent ? (
          <div className="w-full grid lg:grid-cols-2 gap-10">
            <div className="fade-up">
              {eyebrow && (
                <div className="inline-flex items-center gap-2 glass-pill rounded-full px-4 py-1.5 mb-5">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-300" />
                  </span>
                  <span className="text-[11px] uppercase tracking-[0.22em] text-stone-400/90">{eyebrow}</span>
                </div>
              )}
              <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] font-semibold">
                <span className="block text-stone-500">{title}</span>
                {titleAccent && <span className="block text-gradient py-2">{titleAccent}</span>}
              </h1>
              {subtitle && <p className="mt-5 text-stone-500 text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
              {children && <div className="mt-7">{children}</div>}
            </div>
            <div className="hidden h-full lg:flex items-center justify-end fade-up" style={{ animationDelay: "0.12s" }}>
              {rightContent}
            </div>
          </div>
        ) : (
          <div className="max-w-3xl fade-up">
            {eyebrow && (
              <div className="inline-flex items-center gap-2 glass-pill rounded-full px-4 py-1.5 mb-5">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-300" />
                </span>
                <span className="text-[11px] uppercase tracking-[0.22em] text-stone-400/90">{eyebrow}</span>
              </div>
            )}
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] font-semibold">
              <span className="block text-stone-500">{title}</span>
              {titleAccent && <span className="block text-gradient py-2">{titleAccent}</span>}
            </h1>
            {subtitle && <p className="mt-5 text-stone-500 text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
            {children && <div className="mt-7">{children}</div>}
          </div>
        )}
      </div>
    </section>
  );
}
